export function heroSlider() {
    const isIE = this.isIE;
    const _window = window;

    if (isIE()) {
        $(".fnc-slider__slides").slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 400,
            fade: true,
            cssEase: "linear",
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            pauseOnFocus: false,
            pauseOnHover: false,
        });

        setTimeout(() => {
            $(".fnc-slider").addClass("slider-loaded");
            // $(".fnc-slide").css({
            //     "height": `${$(".hero-section").outerHeight()}px`
            // });
        }, 200);

        // _window.addEventListener("resize", () => {
        //     setTimeout(() => {
        //         $(".fnc-slide").css({
        //             "height": `${$(".hero-section").outerHeight()}px`
        //         });
        //     }, 200);
        // });
    } else {
        fncSlider(".hero-slider", {
            autoSlidingDelay: 5000
        });
        document.querySelector("body").setAttribute("data-active-slide", 1);

        setTimeout(() => {
            $(".fnc-slider").addClass("slider-loaded");
        }, 1000);
    }
}

(function () {

    var $$ = function (selector, context) {
        var context = context || document;
        var elements = context.querySelectorAll(selector);
        return [].slice.call(elements);
    };

    function _fncSliderInit($slider, options) {
        var prefix = ".fnc-";

        var $slider = $slider;
        var $slidesCont = $slider.querySelector(prefix + "slider__slides");
        var $slides = $$(prefix + "slide", $slider);

        var numOfSlides = $slides.length;
        var curSlide = 1;
        var sliding = false;
        var slidingAT = +parseFloat(getComputedStyle($slidesCont)["transition-duration"]) * 1000;
        var slidingDelay = +parseFloat(getComputedStyle($slidesCont)["transition-delay"]) * 1000;

        var autoSlidingActive = false;
        var autoSlidingTO;
        var autoSlidingDelay = 5000; // default autosliding delay value
        var autoSlidingBlocked = false;

        var $activeSlide;
        var $activeControlsBg;

        function setIDs() {
            $slides.forEach(function ($slide, index) {
                $slide.classList.add("fnc-slide-" + (index + 1));
            });
        };

        setIDs();

        function afterSlidingHandler() {



            $slider.querySelector(".m--previous-slide").classList.remove("m--active-slide", "m--previous-slide");

            $activeSlide.classList.remove("m--before-sliding");

            sliding = false;
            var layoutTrigger = $slider.offsetTop;

            if (window.pageYOffset === 0) {
                // console.log(window.pageYOffset);
            }
            $('.fnc-slider').removeClass('scrolled-up').removeClass('scrolled-dw');

            if (autoSlidingActive && !autoSlidingBlocked && window.pageYOffset === 0) {
                setAutoslidingTO();
            }


        };

        function performSliding(slideID) {//alert('103');
            if (sliding) return;
            // if (window.pageYOffset > 0) return;
            sliding = true;
            window.clearTimeout(autoSlidingTO);
            curSlide = slideID;



            $activeSlide = $slider.querySelector(prefix + "slide-" + slideID);
            $activeControlsBg = $slider.querySelector(prefix + "nav__bg-" + slideID);

            $slider.querySelector(".m--active-slide").classList.add("m--previous-slide");

            $activeSlide.classList.add("m--before-sliding");

            var layoutTrigger = $activeSlide.offsetTop;

            $activeSlide.classList.add("m--active-slide");




            //myElements[slideID].setAttribute('style', 'visibility: hidden');


            document.querySelector("body").setAttribute("data-active-slide", slideID);


           // }
            setTimeout(afterSlidingHandler, slidingAT + slidingDelay);




            if (window.pageYOffset > 0) return;
        };

        function setAutoslidingTO() {
            window.clearTimeout(autoSlidingTO);
            var delay = +options.autoSlidingDelay || autoSlidingDelay;
            curSlide++;
            if (curSlide > numOfSlides) curSlide = 1;

            autoSlidingTO = setTimeout(function () {
                if(!$('.fnc-slider').hasClass('slider-scrolled') ) {
                    performSliding(curSlide);
                }
            }, delay);
        };

        if (options.autoSliding || +options.autoSlidingDelay > 0) {
            if (options.autoSliding === false) return;

            autoSlidingActive = true;
            setAutoslidingTO();

            $slider.classList.add("m--with-autosliding");
            var triggerLayout = $slider.offsetTop;

            var delay = +options.autoSlidingDelay || autoSlidingDelay;
            delay += slidingDelay + slidingAT;
        }

        window.addEventListener("scroll", function (event) {
            if (autoSlidingActive && !autoSlidingBlocked && window.pageYOffset === 0) {
                $slider.classList.remove("slider-scrolled");
                setAutoslidingTO();
            }

            if (window.pageYOffset > 0) {
                $slider.classList.add("slider-scrolled");
            }
        });

    };

    var fncSlider = function (sliderSelector, options) {
        var $sliders = $$(sliderSelector);

        $sliders.forEach(function ($slider) {
            _fncSliderInit($slider, options);
        });
    };

    window.fncSlider = fncSlider;
}());


// WEBPACK FOOTER //
// ./assets/js/modules/hero-slider.js